<div class="create-profile">
  <div class="create-profile__gif">
    <layout-loader-gif [size]="103"></layout-loader-gif>
  </div>
  <h3 class="create-profile__title">Creando tu perfil Powerpay</h3>
  <p class="create-profile__description">
    La operación puede tardar unos segundos, por<br class="desktop" />favor espera y no actualices
    esta pantalla.
  </p>
</div>
